/* eslint-disable @typescript-eslint/no-explicit-any */

import { ModalRef, useApiClient, useEntityMetadata, useTranslation } from '@msdk/common'
import {
  Entity,
  EntityMetadata,
  EntityModel,
  readBaseMetadataByName,
  readEntityModelByName,
  readUserData,
  StringValue,
  TenantPath,
} from '@msdk/definitions'
import { ButtonPrimary, Card, CardBody, FormField, MenuItem, styled, StyledSelect } from '@msdk/ui'
import { useEffect, useState } from 'react'
import { MAX_INT } from 'utils'

const ControlsColumn = styled('div')`
  display: flex;
  flex-direction: column;
`

const Container = styled('div')`
  width: 800px;
`

interface Props {
  modalRef?: ModalRef
}

function IsTechServCustomizationEnabled(): boolean {
  const tenantPath = new TenantPath()
  return tenantPath.IsCustomizationEnabled('TECH_SERV')
}

export function DefaultClinicSelector(props: Props) {
  const t = useTranslation()
  const client = useApiClient()
  const buMetadata = useEntityMetadata('BUSINESS_UNIT')
  const [availableClinics, setAvailableClinics] = useState<Entity[]>([])
  const [selectedClinicId, setSelectedClinicId] = useState<string>('')
  const [originalClinicId, SetOriginalClinicId] = useState<string>('')
  const [techServCustomizationEnabled] = useState<boolean>(IsTechServCustomizationEnabled())

  useEffect(() => {
    const fetchData = async () => {
      const res = await client.entity.getView('USM', buMetadata as EntityModel, 'BUSINESS_UNIT_SELECTION', {
        filters: {
          '@USER_ID': new StringValue(readUserData().user_id as string),
        },
        pageSize: MAX_INT,
      })

      const clinicList: Entity[] = res.source && res.source.length > 0 ? res.source : []
      setAvailableClinics(clinicList)
      const entityModel = readEntityModelByName('USER')
      const baseMetatdata = readBaseMetadataByName('USER') as EntityMetadata
      const loggedUserEntity: Entity = (
        await client.entity.getEntity(
          baseMetatdata.msProvider,
          readUserData().user_id as string,
          entityModel as EntityModel,
        )
      ).entities[0]
      if (loggedUserEntity.fields['DEFAULT_BU'] && loggedUserEntity.fields['DEFAULT_BU'].value) {
        setSelectedClinicId(loggedUserEntity.fields['DEFAULT_BU'].value)
        SetOriginalClinicId(loggedUserEntity.fields['DEFAULT_BU'].value)
      }
    }
    fetchData().catch(console.error)
  }, [])

  const handleSubmit = async (event: any) => {
    event.preventDefault()
    let urlToCall
    if (selectedClinicId)
      urlToCall = `USM/api/UserManagement/SetDefaultBu/${selectedClinicId ? selectedClinicId : null}`
    else urlToCall = `USM/api/UserManagement/UnsetDefaultBu`

    await client.update(urlToCall, null)

    props.modalRef?.close()
  }

  const handleClinicChange = (event: any) => {
    setSelectedClinicId(event.target.value)
  }

  return (
    <Container>
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <ControlsColumn>
              <h1>
                {techServCustomizationEnabled
                  ? t('CMPSR_DEFAULT_REGION_SEL', 'Default region selection')
                  : t('CMPSR_DEFAULT_CLINIC_SEL', 'Default clinic selection')}
              </h1>
              <FormField>
                <StyledSelect value={selectedClinicId} onChange={handleClinicChange}>
                  <MenuItem value="" key="">
                    {' '}
                    -{' '}
                  </MenuItem>
                  {availableClinics.map((bu) => (
                    <MenuItem value={bu.id} key={bu.id}>
                      {bu.fields['NAME']?.value}
                    </MenuItem>
                  ))}
                </StyledSelect>
              </FormField>
              <ButtonPrimary
                variant="contained"
                type="submit"
                disabled={selectedClinicId == originalClinicId}
                style={{ marginTop: 20 }}
              >
                {t('CMPSR_SAVE', 'Save')}
              </ButtonPrimary>
            </ControlsColumn>
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}
